import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CompanyAppraisal<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getCompanyAppraisalSettings = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/setting/appraisal`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyAppraisalSettings = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/setting/appraisal`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalTemplate = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCompanyAppraisalTemplate = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/template`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalTemplateById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/template/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyAppraisalTemplateById = (
    id: string,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/template/${id}`,
      method: 'PATCH',
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addManualCompanyAppraisal = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/manual`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalReviews = (
    query: {
      status: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/reviews`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalReviewsParams = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/reviews/params`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalMapping = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/mappers`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyAppraisalMapping = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/mappers`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalMappingSettings = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/mappers/settings`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalReviewById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/reviews/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyAppraisalReviewById = (
    id: string,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/reviews/${id}`,
      method: 'PATCH',
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalReport = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/report`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAppraisalReportV2 = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/appraisals/report/v2`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
